import usePropertyForm, { STEP_INFO, STEP_SETUP, BLOQUE_TIPOS, bloqueTipoInfo, FIELD_MAX_LENGTH } from './usePropertyForm';
import { Link } from 'react-router-dom';
import SearchableSelect from 'components/SearchableSelect';
import styles from './PropertyForm.module.css';
export { BLOQUE_TIPOS } from './usePropertyForm';

// Genera preview de unidades
function buildPreview(towers, floors, unitsPerFloor) {
  const result = [];
  const MAX_CHIPS = 12;
  for (let t = 1; t <= Math.min(towers, 4); t++) {
    const units = [];
    outer:
    for (let p = 1; p <= floors; p++) {
      for (let u = 1; u <= unitsPerFloor; u++) {
        if (units.length >= MAX_CHIPS) break outer;
        units.push(`${p}${String(u).padStart(2, '0')}`);
      }
    }
    const total = floors * unitsPerFloor;
    result.push({ torre: t, units, total });
  }
  return result;
}

export default function PropertyForm() {
  const {
    step, setStep, form, bloques, loading, error, loadingData, isEdit, chForm, chBloque, chBloqueTipo,
    addBloque, removeBloque, submitEdit, nextStep, submitCreate, totalUnitsAll,
  } = usePropertyForm();

  // ── EDITAR: form simple ──────────────────────────────────────────────────────
  if (isEdit) return (
    <div>
      <div className="page-header">
        <div><h1>Editar Propiedad</h1></div>
        <Link to="/admin/propiedades" className="btn btn-secondary"><i className="fas fa-arrow-left" /> Volver</Link>
      </div>
      {error && <div className="alert alert-danger">{error}</div>}
      {loadingData && <div className="loading"><div className="spinner" /></div>}
      <div className="card"><div className="card-body">
        <form onSubmit={submitEdit} noValidate>
          <div className={styles.rejilla}>
            {[['name','Nombre *'],['address','Dirección *'],['city','Ciudad *'],['phone','Teléfono *'],['nit','NIT *']].map(([n,l]) => (
              <div className="form-group" key={n}>
                <label className={styles.etiqueta}>{l}</label>
                <input name={n} className="form-control" value={form[n]} onChange={chForm}
                  required={l.includes('*')} maxLength={FIELD_MAX_LENGTH[n]} />
              </div>
            ))}
            <div className="form-group">
              <label className={styles.etiqueta}>Tipo de propiedad</label>
              <SearchableSelect value={form.tipo_propiedad} onChange={(v) => chForm({ target: { name: 'tipo_propiedad', value: v } })} minWidth={0} maxWidth={9999} allowEmpty={false} ariaLabel="Tipo de propiedad" options={[{ value: 'residencial', label: 'Residencial' }, { value: 'comercial', label: 'Comercial' }, { value: 'mixto', label: 'Mixto' }]} />
            </div>
          </div>
          <div className={styles.filaBotones}>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              <i className="fas fa-save" /> {loading ? 'Guardando...' : 'Actualizar'}
            </button>
            <Link to="/admin/propiedades" className="btn btn-secondary">Cancelar</Link>
          </div>
        </form>
      </div></div>
    </div>
  );

  // ── CREAR: wizard ────────────────────────────────────────────────────────────
  return (
    <div className={styles.contenedor}>
      <div className="page-header">
        <div>
          <h1><i className={`fas fa-building ${styles.iconoCabecera}`} />Nueva Propiedad</h1>
          <p>{step === STEP_INFO ? 'Información general' : 'Configuración de torres y unidades'}</p>
        </div>
        <Link to="/admin/propiedades" className="btn btn-secondary"><i className="fas fa-arrow-left" /> Volver</Link>
      </div>

      {/* Stepper */}
      <div className={styles.pasos}>
        {[{ n: 1, label: 'Información' }, { n: 2, label: 'Torres y Unidades' }].map(({ n, label }, i) => (
          <div key={n} className={styles.paso}>
            <div className={styles.pasoGrupo}>
              <div className={`${styles.pasoCirculo} ${step >= n ? styles.pasoCirculoActivo : ''}`}>{n}</div>
              <span className={`${styles.pasoTexto} ${step >= n ? styles.pasoTextoActivo : ''}`}>{label}</span>
            </div>
            {i < 1 && <div className={`${styles.pasoLinea} ${step > n ? styles.pasoLineaListo : ''}`} />}
          </div>
        ))}
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      {/* PASO 1: Información */}
      {step === STEP_INFO && (
        <div className="card"><div className="card-body">
          <form onSubmit={nextStep} noValidate>
            <div className={styles.rejilla}>
              {[['name','Nombre *'],['address','Dirección *'],['city','Ciudad *'],['phone','Teléfono *'],['nit','NIT *']].map(([n,l]) => (
                <div className="form-group" key={n}>
                  <label className={styles.etiqueta}>{l}</label>
                  <input name={n} className="form-control" value={form[n]} onChange={chForm}
                    required={l.includes('*')} maxLength={FIELD_MAX_LENGTH[n]} />
                </div>
              ))}
              <div className="form-group">
                <label className={styles.etiqueta}>Tipo de propiedad</label>
                <SearchableSelect value={form.tipo_propiedad} onChange={(v) => chForm({ target: { name: 'tipo_propiedad', value: v } })} minWidth={0} maxWidth={9999} allowEmpty={false} ariaLabel="Tipo de propiedad" options={[{ value: 'residencial', label: 'Residencial' }, { value: 'comercial', label: 'Comercial' }, { value: 'mixto', label: 'Mixto' }]} />
              </div>
            </div>
            <div className={styles.filaDerecha}>
              <button type="submit" className="btn btn-primary">
                Siguiente <i className="fas fa-arrow-right" />
              </button>
            </div>
          </form>
        </div></div>
      )}

      {/* PASO 2: Bloques (torres, casas, locales...) */}
      {step === STEP_SETUP && (
        <form onSubmit={submitCreate} noValidate>
          <div className={styles.resumenBloques}>
            <i className={`fas fa-info-circle ${styles.icono6}`} />
            {bloques.length} bloque{bloques.length !== 1 ? 's' : ''} ·{' '}
            <span className={styles.totalGrande}>{totalUnitsAll}</span> unidades en total
          </div>

          <div className={styles.listaBloques}>
            {bloques.map((b, idx) => {
              const preview     = buildPreview(b.towers, b.floors, b.units_per_floor);
              const totalBloque = b.towers * b.floors * b.units_per_floor;
              return (
                <div className="card" key={idx}><div className="card-body">
                  <div className={styles.bloqueCabecera}>
                    <h3 className={styles.bloqueTitulo}>
                      <i className={`fas fa-layer-group ${styles.iconoBloque}`} />
                      Bloque {idx + 1}
                    </h3>
                    {bloques.length > 1 && (
                      <button type="button" className="btn btn-sm btn-danger btn-icon"
                        onClick={() => removeBloque(idx)} title="Eliminar bloque">
                        <i className="fas fa-trash" />
                      </button>
                    )}
                  </div>

                  <div className={styles.bloqueRejilla}>
                    {/* Configuración del bloque */}
                    <div className={styles.columnaBloque}>
                      <div className="form-group">
                        <label className={styles.etiqueta}>Tipo de bloque</label>
                        <SearchableSelect value={b.tipo} onChange={(v) => chBloqueTipo(idx, v)} minWidth={0} maxWidth={9999} allowEmpty={false} ariaLabel="Tipo de bloque" options={BLOQUE_TIPOS.map(t => ({ value: t.key, label: t.label }))} />
                      </div>

                      <div className="form-group">
                        <label className={styles.etiqueta}>{bloqueTipoInfo(b.tipo).towersLabel}</label>
                        <input type="number" className="form-control"
                          value={b.towers} onChange={e => chBloque(idx, 'towers', e.target.value)} min="1" max="200" />
                        <div className={styles.notaCantidad}>
                          {b.towers > 1
                            ? `Se crearán: "${b.label} 1", "${b.label} 2"...`
                            : `Se creará "${b.label} 1"`}
                        </div>
                      </div>
                      {bloqueTipoInfo(b.tipo).hasFloors && (
                        <div className="form-group">
                          <label className={styles.etiqueta}>Pisos {b.floors === 1 ? '(1 = sin niveles, lista plana)' : ''}</label>
                          <input type="number" className="form-control"
                            value={b.floors} onChange={e => chBloque(idx, 'floors', e.target.value)} min="1" max="200" />
                        </div>
                      )}
                      {!bloqueTipoInfo(b.tipo).singleUnit && (
                        <div className={`form-group ${styles.grupoSinMargen}`}>
                          <label className={styles.etiqueta}>
                            {bloqueTipoInfo(b.tipo).hasFloors
                              ? `${bloqueTipoInfo(b.tipo).unitLabel} por piso`
                              : bloqueTipoInfo(b.tipo).unitLabel}
                          </label>
                          <input type="number" className="form-control"
                            value={b.units_per_floor} onChange={e => chBloque(idx, 'units_per_floor', e.target.value)} min="1" max="600" />
                        </div>
                      )}
                    </div>

                    {/* Vista previa del bloque */}
                    <div className={styles.columnaVista}>
                      <div className={styles.vistaTitulo}>
                        Vista previa {b.towers > 4 || b.floors > 6 || b.units_per_floor > 6 ? '(parcial)' : ''}
                      </div>
                      <div className={styles.vistaLista}>
                        {preview.map(({ torre, units, total }) => (
                          <div key={torre} className={styles.torreCaja}>
                            <div className={styles.torreCabecera}>
                              <span className={styles.torreNombre}>
                                <i className={`fas fa-building ${styles.icono6}`} />
                                {`${b.label || 'Bloque'} ${torre}`}
                              </span>
                              <span className={styles.torreTotal}>{total} unidades</span>
                            </div>
                            <div className={styles.chips}>
                              {units.map(u => (
                                <span key={u} className={styles.chip}>{u}</span>
                              ))}
                              {total > units.length && (
                                <span className={styles.chipsMas}>
                                  +{total - units.length} más...
                                </span>
                              )}
                            </div>
                          </div>
                        ))}
                        {b.towers > 4 && (
                          <p className={styles.masTorres}>
                            +{b.towers - 4} más se crearán
                          </p>
                        )}
                      </div>
                      <div className={styles.totalBloque}>
                        <b className={styles.totalCifra}>{totalBloque}</b> unidades en este bloque
                      </div>
                    </div>
                  </div>
                </div></div>
              );
            })}
          </div>

          <button type="button" className={`btn btn-secondary ${styles.botonAgregar}`} onClick={addBloque}>
            <i className="fas fa-plus" /> Agregar otro bloque
          </button>

          <div className={styles.pie}>
            <button type="button" className="btn btn-secondary" onClick={() => setStep(STEP_INFO)}>
              <i className="fas fa-arrow-left" /> Atrás
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading
                ? <><div className={`spinner ${styles.spinner16}`} /> Creando...</>
                : <><i className="fas fa-check" /> Crear propiedad</>}
            </button>
          </div>
        </form>
      )}
    </div>
  );
}